<template>
  <div class="contarner" >
    <div class="tip" >
      <p class="title" >应用中心</p>
      <p class="content" >免安装、快速配置、高拓展</p>
    </div>
    <div class="boxs" >
      <div class="box" >
        <img class="img" src="./shop.png" alt="" v-zoomIn >
        <p class="text" >移动巡店</p>
      </div>
      <div class="box" >
        <img class="img" src="./train.png" alt="" v-zoomIn >
        <p class="text" >培训考试</p>
      </div>
      <div class="box" >
        <img class="img" src="./formula.png" alt="" v-zoomIn >
        <p class="text" >电子配方</p>
      </div>
      <div class="box" >
        <img class="img" src="./store-cap.png" alt="" v-zoomIn >
        <p class="text" >固定资产</p>
      </div>
      <div class="box" >
        <img class="img" src="./workflow.png" alt="" v-zoomIn >
        <p class="text" >任务助手</p>
      </div>
      <div class="box" >
        <img class="img" src="./task.png" alt="" v-zoomIn >
        <p class="text" >智能表单</p>
      </div>
      <div class="box" >
        <img class="img" src="./check.png" alt="" v-zoomIn >
        <p class="text" >移动订货</p>
      </div>
      <div class="box" >
        <img class="img" src="./basehrm.png" alt="" v-zoomIn >
        <p class="text" >考勤排班</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  methods: {

  }
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.contarner {
  background-color: #fff;
  padding: 40px 0;
  margin: 0 auto;
  overflow: hidden;

  .tip {
    text-align: center;

    .title {
      font-size: 25px;
      font-weight: 500;
    }

    .content {
      font-size: 15px;
      color: #666;
      margin-bottom: 30px;
    }
    @media screen and (max-width: 500px){
      .title {
        font-size: 18px;
      }

      .content {
        font-size: 12px;
      }
    }
  }

  .boxs {
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    width: 80%;
    max-width: 1000px;
    margin: 0 auto;

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      width: 25%;
      margin-bottom: 15px;

      .img {
        height: 100px;
        width: 100px;
      }
    }

    @media screen and (max-width: 750px) {
      .box {
        width: 50%;
        font-size: 14px;

        .img {
          height: 60px;
          width: 60px;
        }
      }
    }
  }

}
</style>
